import { css } from "@emotion/react";
import { useTranslations } from "next-intl";

import { Icon } from "@zapier/zinnia-icons";
import {
  Colors,
  Tooltip,
  TooltipFocusableTrigger,
} from "@zapier/design-system";

const arrowStyle = css`
  align-items: center;
  border: 1px transparent solid;
  border-radius: 3px;
  display: grid;
  grid-auto-flow: column;
  padding: 6px;
  transition:
    background-color 0.5s ease,
    border 0.5s ease;

  &:hover {
    background-color: ${Colors.UiPrimaryWeaker};
    color: ${Colors.UiPrimaryStrongest};
  }
`;

/**
 * Arrow icon with custom styling and a tooltip to be displayed at the end of each row.
 */
function Arrow() {
  const t = useTranslations("run-log.arrow");

  return (
    <Tooltip content={t("tooltip")} placement="bottom right">
      <TooltipFocusableTrigger>
        <div css={arrowStyle}>
          <Icon color="currentColor" name="arrowBigRight" size={26} />
        </div>
      </TooltipFocusableTrigger>
    </Tooltip>
  );
}

export default Arrow;
